import { useState, useCallback, useRef } from 'react';
import axiosInstance from '../axiosInstance';
import { endpoints } from '../endPoints';
import useToggle from 'shared/hooks/use-toggle';
import toast from 'react-hot-toast';

const useSessionService = () => {
  const [sessions, setSessions] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isLoading, toggleLoading] = useToggle();
  const lastFetchKey = useRef(null);

  const fetchSessions = useCallback(async (userId, page = 0, size = 10) => {
    if (!userId) return;

    const fetchKey = `${userId}:${page}:${size}`;
    if (lastFetchKey.current === fetchKey) return;
    lastFetchKey.current = fetchKey;

    toggleLoading();
    try {
      const response = await axiosInstance.get(
        `${endpoints.sessions.getUserSessions}?page=${page}&size=${size}&userId=${encodeURIComponent(userId)}`
      );

      if (response?.data?.data) {
        const { records, data } = response.data.data;
        setTotalRecords(records ?? 0);
        setSessions(Array.isArray(data) ? data : []);
      } else {
        throw new Error('Invalid response format');
      }
    } catch (error) {
      lastFetchKey.current = null;
      console.error('Error fetching sessions:', error);
      toast.error(error.response?.data?.message || 'Error fetching sessions');
    } finally {
      toggleLoading();
    }
  }, [toggleLoading]);

  return { sessions, totalRecords, fetchSessions, isLoading };
};

export default useSessionService;
